export default __webpack_public_path__ + "static/media/support.312741d5.svg";